export default __webpack_public_path__ + "static/media/image11.be1283c4.png";